import React from 'react'
import Breadcrumb from '../BreadCrumb/BreadCrumb'
import HomeContact from '../container/HomeContainer/HomeContact'
import BlogOne from '../container/PagesContainer/BlogOne'
import Footer from '../footer/Footer'
import MainNavigation from '../nav/MainNavigation'
import SEO from '../SEO/SEO'


function Blogs() {
    return (
        <React.Fragment>
            <SEO title="Dr Bupathi Gastro and Laparoscopy || Blogs" />
            <MainNavigation />
            <Breadcrumb image="/images/pages/blog.jpg" title="Home" content="Blogs" />
            <BlogOne />
            <HomeContact />
            <Footer />
        </React.Fragment>
    )
}

export default Blogs